import { AuthLayout } from "@/components/auth/AuthLayout";
import { LoginForm } from "@/components/auth/LoginForm";

export default function Login() {
  return (
    <AuthLayout
      title="Bem-vindo ao Nexus Q, o Software de Gestão da Qualidade da Atmis Gestão"
      subtitle="Faça login com sua conta corporativa Microsoft"
    >
      <LoginForm />
    </AuthLayout>
  );
}
